import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import callReducer from './slices/callSlice';
import customerReducer from './slices/customerSlice';
import caseReducer from './slices/caseSlice';
import alertsReducer from './slices/alertsSlice';
import dynamicAiSuggestionReducer from './slices/dynamicAiSuggestionSlice';
import warmTransferReducer from './slices/warmTransferSlice';
import { api } from './api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    call: callReducer,
    customer: customerReducer,
    case: caseReducer,
    alerts: alertsReducer,
    dynamicAiSuggestion: dynamicAiSuggestionReducer,
    warmTransfer: warmTransferReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
